import { useState } from "react";
import { Button } from "./Button";
import { useLayoutStyles } from "./styles";

interface ConfirmButtonProps {
  label: string;
  confirmLabel: string;
  pending?: boolean;
  onConfirm: () => void;
}

/** A destructive action that needs a second, explicit click. */
export const ConfirmButton = ({
  label,
  confirmLabel,
  pending = false,
  onConfirm,
}: ConfirmButtonProps) => {
  const layout = useLayoutStyles();
  const [asking, setAsking] = useState(false);
  if (!asking) {
    return (
      <Button
        variant="danger"
        small
        disabled={pending}
        onClick={() => setAsking(true)}
      >
        {pending ? "Working…" : label}
      </Button>
    );
  }
  return (
    <span className={layout.inlineGroup}>
      <Button
        variant="danger"
        small
        onClick={() => {
          setAsking(false);
          onConfirm();
        }}
      >
        {confirmLabel}
      </Button>
      <Button variant="ghost" small onClick={() => setAsking(false)}>
        Keep
      </Button>
    </span>
  );
};
